import { usePaymentMethodsStateContext } from '../context/payment-methods-state.context';
import { PaymentMethodsView } from '../types/provider.types';

export type PaymentMethodsViewSwitchProps = React.PropsWithChildren<{
  view: PaymentMethodsView;
}>;
export const PaymentMethodsViewSwitch = ({ children, view: targetView }: PaymentMethodsViewSwitchProps) => {
  const { view } = usePaymentMethodsStateContext();

  if (view !== targetView) {
    return null;
  }

  return (
    <div className='payment-methods-view' data-view={view}>
      {children}
    </div>
  );
};
